import { connect } from 'react-redux'
import { payReservation } from './reducer'

const mapStateToProps = (state) => {
    return {
        tickets: state?.pages.accountOrders?.tickets ?? [],
        reservations: state?.pages.accountOrders?.reservations ?? [],
        loading: state?.components.mainLoader?.loading,
    }
}

const mapDispatchToProps = { payReservation }

const hocTicketsAndReserv = (InnerComponent) => connect(mapStateToProps, mapDispatchToProps)(InnerComponent)

export default hocTicketsAndReserv
